import React, { useState } from "react";
import "./EventModal.css";

const EventModal = ({ date, onClose, onSave }) => {
  const [title, setTitle] = useState("");
  const [status, setStatus] = useState("draft");
  const [time, setTime] = useState("");
  const [timezones, setTimezones] = useState([]);
  const [notes, setNotes] = useState("");
  const [country, setCountry] = useState("US");
  const [description, setDescription] = useState("");

  const handleSubmit = () => {
    onSave({
      title,
      event_date: date,
      status,
      scheduled_time: status === "schedule" ? time : null,
      timezones: status === "schedule" ? timezones : [],
      notes: notes || "",
      country,
      description
    });
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h3>Create Event ({date})</h3>

        <input
          placeholder="Event Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />

        <input
          placeholder="Country (e.g., US, IN)"
          value={country}
          onChange={(e) => setCountry(e.target.value)}
        />

        <textarea
          placeholder="Event Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />

        <select value={status} onChange={(e) => setStatus(e.target.value)}>
          <option value="publish">Publish</option>
          <option value="schedule">Schedule</option>
          <option value="draft">Draft</option>
        </select>

        {status === "schedule" && (
          <div className="status-box schedule schedule-section">
            <label>Pick Date & Time</label>
            <input
              type="datetime-local"
              onChange={(e) => setTime(e.target.value)}
            />
            <label>Timezones</label>
            <select
              multiple
              value={timezones}
              onChange={(e) =>
                setTimezones(Array.from(e.target.selectedOptions, o => o.value))
              }
            >
              <option value="EST">EST</option>
              <option value="CST">CST</option>
              <option value="PST">PST</option>
              <option value="MST">MST</option>
              <option value="GMT">GMT</option>
            </select>
          </div>
        )}

        {status === "draft" && (
          <div className="status-box draft schedule-section">
            <p>This will be saved as a private draft.</p>
            <textarea
              placeholder="Add notes / requirements (optional)"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
            />
          </div>
        )}

        <div className="modal-actions">
          <button onClick={handleSubmit}>Save</button>
          <button onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default EventModal;